import React, { useState, useEffect } from "react";
import noWifi from "./Images/no-wifi.png"
const NoInternet = (props) => {
    const [isOnline, setOnline] = useState(true);
    useEffect(() => {
        setOnline(navigator.onLine);
    }, []);

    window.addEventListener("online", () => {
        setOnline(true);
    });

    window.addEventListener("offline", () => {
        setOnline(false);
    });
    const handleTryAgain = () => {
            window.location.reload(); 
    };
    if (isOnline) {
        return props.children;
    } else {
        return (
            <div className="no-internet-container">
                <div className="text-center page-inner shadow-md rounded-3">
                    <img src={noWifi} alt="" />
                    <h2 className="error-message">Ooops!</h2>
                    <p className="sub-message">No Internet connection found. Check your connection.</p>
                    <button
                        className="try-again-btn rounded-1"
                        onClick={handleTryAgain}
                    >
                        Try Again
                    </button>
                </div>
            </div>);
    }
};

export default NoInternet;
